// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function HandPointingBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M23.5 10.5a3.994 3.994 0 0 0-1.402.25A4 4 0 0 0 17.5 8.625V5.5a4 4 0 0 0-8 0v8.354A4 4 0 0 0 3.031 18.5l.585 1.03C7.89 27.06 9.84 30.5 16 30.5A11.512 11.512 0 0 0 27.5 19v-4.5a4 4 0 0 0-4-4Zm1 8.5a8.51 8.51 0 0 1-8.5 8.5c-4.25 0-5.436-1.806-9.775-9.456l-.586-1.035a.02.02 0 0 1 0-.009 1 1 0 1 1 1.732-1l.025.044 2.335 3.75A1.5 1.5 0 0 0 12.5 19V5.5a1 1 0 1 1 2 0V14a1.5 1.5 0 1 0 3 0v-1.5a1 1 0 1 1 2 0V15a1.5 1.5 0 1 0 3 0v-.5a1 1 0 1 1 2 0V19Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
